import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_flammablecombustible_materials_safely_stored'

export const dataPointDefinition = {
  retracedId: 'are_flammablecombustible_materials_safely_stored',
  name: 'Are flammable/combustible materials safely stored?',
  description:
    'Answer Yes if flammable materials such as paper, fabrics, wood, plastics, packaging materials etc. are NOT stored in ANY of the following:\r\r\n- beneath stair cases or in stair wells;\r\r\n- up against heating equipment; \r\r\n- close to electrical cabinets or equipment;\r\r\n- near sources of heat.\r\r\n\r\r\nIf the facility does not have any flammable/combustible materials, answer Not Applicable.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fla-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15150,
  sectionId: '2.2.9.2',
  impactArea: 'Flammable and Combustible Materials',
  impactAreaId: 'FLAMMABLE_AND_COMBUSTIBLE_MATERIALS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
